var map = {
	"./vue": "./app/frontend/scripts/pages/application/vue.js",
	"./vue.js": "./app/frontend/scripts/pages/application/vue.js"
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./app/frontend/scripts/pages/application lazy recursive ^.*$";
module.exports = webpackAsyncContext;